// extracted by mini-css-extract-plugin
export default {"Header":"styles_Header__WbPcy","backBtn":"styles_backBtn__sh4Y+","title":"styles_title__h7R33","arrow":"styles_arrow__vMFEl"};